import { itwApi } from "../middlewares/api";
const getSystemPreviewDetail = async (id) => {
    var response = await itwApi.get(`System/preview-system?SystemId=${id}`);
    return response.data;
};
const getFilteredSystemDetail = async (query) => {
    const response = await itwApi.post('System/filtered-system-details', query);
    return response.data;
};
const fetchIncidnetsPreviewDetail = async (id) => {
    const response = await itwApi.get('Incident/get-preview-for-incident-detail', {
        params: { id }
    });
    return response.data;
};
const getSystems = async () => {
    const response = await itwApi.get('system/get-systems');
    return response.data;
};
const getAssetSystems = async (id) => {
    var response = await itwApi.get(`system/get-asset-systems?AssetId=${id}`);
    return response.data;
};
export const systemApi = {
    getSystemPreviewDetail,
    getFilteredSystemDetail,
    fetchIncidnetsPreviewDetail,
    getSystems,
    getAssetSystems
};
